export const SCOPES = {
  canCreate: 'can-create',
  canEdit: 'can-edit',
  canDelete: 'can-delete',
  canView: 'can-view',
  canViewImpersonated: 'can-view-impersonated',
  canViewDepersonated: 'can-view-depersonated',
  actionAllowed: 'action-allowed'
};
